// product list
export const HOTEL_PROPERTY_POST_REQUEST = 'HOTEL_PROPERTY_POST_REQUEST';
export const HOTEL_PROPERTY_POST_SUCCESS = 'HOTEL_PROPERTY_POST_SUCCESS';
export const HOTEL_PROPERTY_POST_ERROR = 'HOTEL_PROPERTY_POST_ERROR'; 
